import 'consumerweb-shim';
import React from 'react';
import { connect } from 'react-redux';

import Charity from '../../charity';

import * as ViewActions from '../actions/Actions';
import * as analytics from '../../../lib/analytics';

import content from '../../../lib/i18n';
const i18n = content('multiCharityFundraiser/components/CharityMain');

export class CharityContainer extends React.Component {
  componentDidMount() {}

  handleCharityClick = (selectedIndex, source, npid) => {
    this.props.dispatch(ViewActions.selectedCharity(selectedIndex, source));

    analytics.trackLinkWithData(
      'charity',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  handleInfoClick = (selectedIndexCharityInfo, source, npid) => {
    // this.props.dispatch(
    //   ViewActions.selectedCharityInfo(selectedIndexCharityInfo, source)
    // );

    analytics.trackLinkWithData(
      'infoIcon',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { crid: npid },
      'link'
    );
  };

  handleDefaultCharityState = source => {
    this.props.dispatch(ViewActions.defaultState(source));
  };

  handlePopOverClose = source => {
    this.props.dispatch(ViewActions.defaultPopoverState(source));
  };

  handleSeeMore = source => {
    this.props.dispatch(ViewActions.expandSeeMore(source));
  };

  render() {
    let npoBaseUrl = `/fundraiser/${this.props.campaignId}/charity/`;
    return (
      <div>
        <Charity
          onHandleClick={this.handleCharityClick}
          onInfoClick={this.handleInfoClick}
          onPopoverClose={this.handlePopOverClose}
          onHandleDefaultCharityState={this.handleDefaultCharityState}
          handleSeeMore={this.handleSeeMore}
          charityModuleTitleDefault={i18n('title.charity-module-title')}
          charityModuleChooseAmountTextDefault={i18n(
            'title.charity-module-choose-amount'
          )}
          npoBaseUrl={npoBaseUrl}
          source='featured'
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(state => ({
  // connects reducer with component
  csrf: state.server.csrf,
  data: state.server.data,
  coBrand: state.server.coBrand,
  selectedCharity: state.charity.featured.selectedCharity,
  selectedIndex: state.charity.featured.selectedIndex,
  seeMoreClicked: state.charity.featured.seeMoreClicked,
  selectedIndexCharityInfo: state.charity.featured.selectedIndexCharityInfo,
  charityModuleTitle:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.header,
  charityModuleSubHeader:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.subHeader,
  charityModuleChooseAmountText:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.chooseAmountText,
  clickedRadioBtn: state.charity.featured.clickedRadioBtn,
  charities: state.server.data.charities,
  amounts: state.server.data.amounts,
  donateButtonText:
    state.server.templateData.donationModule &&
    state.server.templateData.donationModule.donateButtonText,
  campaignId: state.server.campaignId,
  campaignState: state.server.data.state,
}))(CharityContainer);
